import { render, staticRenderFns } from "./menu-tree.vue?vue&type=template&id=5f648c42&scoped=true&lang=pug&"
import script from "./menu-tree.vue?vue&type=script&lang=js&"
export * from "./menu-tree.vue?vue&type=script&lang=js&"
import style0 from "./menu-tree.vue?vue&type=style&index=0&id=5f648c42&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f648c42",
  null
  
)

export default component.exports